import { UnderageSubmissionData } from 'types/underage';
import { create } from 'zustand';

interface CapturedFile {
  base64: string;
  timestamp: number;
}

interface UnderageState {
  capturedFile: CapturedFile | null;
  idCardFile: CapturedFile | null;
  createdAt: number;
  isUploading: boolean;
  isFromVerification: boolean;

  // Actions
  setCapturedFile: (file: CapturedFile) => void;
  setIdCardFile: (file: CapturedFile | null) => void;
  setUploading: (uploading: boolean) => void;
  setFromVerification: (isFromVerification: boolean) => void;
  getSubmissionData: (comment?: string) => UnderageSubmissionData | null;
  reset: () => void;
}

const useUnderageStore = create<UnderageState>((set, get) => ({
  capturedFile: null,
  idCardFile: null,
  createdAt: Date.now(),
  isUploading: false,
  isFromVerification: false,

  setCapturedFile: (capturedFile) => {
    set({ capturedFile });
  },
  setIdCardFile: (idCardFile) => set({ idCardFile }),
  setUploading: (isUploading) => set({ isUploading }),
  setFromVerification: (isFromVerification) => set({ isFromVerification }),

  getSubmissionData: (comment) => {
    const { capturedFile, idCardFile, createdAt } = get();
    if (!capturedFile || !idCardFile) return null;

    return {
      comment,
      fbUid: myinfo?.fbUid || '',
      createdAt,
      faceImageData: capturedFile.base64,
      idCardImageData: idCardFile.base64,
    };
  },

  reset: () =>
    set({
      capturedFile: null,
      idCardFile: null,
      createdAt: Date.now(),
      isUploading: false,
      isFromVerification: false,
    }),
}));

export default useUnderageStore;
